export default "__VITE_ASSET__BclZxZry__"